"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var QueryJoinType;
(function (QueryJoinType) {
    QueryJoinType["OR"] = "OR";
    QueryJoinType["AND"] = "AND";
})(QueryJoinType = exports.QueryJoinType || (exports.QueryJoinType = {}));
//# sourceMappingURL=QueryJoinType.js.map